<template>
  <div style="width: 100%;height: 100%; overflow: auto">
    <div style="margin: 10px;border: 1px solid gray;display: flex;flex-wrap: wrap;">
      <div style="margin: 10px 0 0 10px;background-color: #108ffe;width: 5px;height: 30px"></div>
      <div style="margin: 10px 0 10px 5px;width: calc(100% - 50px);height: 30px;line-height: 30px">基础信息</div>
      <div >
      <frame-form ref="toolProductForm" component-param="tool_product_form"></frame-form>
      </div>
    </div>

    <div>
      <div style="margin: 10px;border: 1px solid gray;display: flex;flex-wrap: wrap;">
        <div style="margin: 10px 0 0 10px;background-color: #108ffe;width: 5px;height: 30px"></div>
        <div style="margin: 10px 0 10px 5px;width: calc(100% - 50px);height: 30px;line-height: 30px">软件详情</div>
        <div >
          <frame-form ref="toolItemDetail" component-param="tool_product_item_form"></frame-form>
        </div>
      </div>
    </div>

    <div>
      <div style="margin: 10px;border: 1px solid gray;display: flex;flex-wrap: wrap;">
        <div style="margin: 10px 0 0 10px;background-color: #108ffe;width: 5px;height: 30px"></div>
        <div style="margin: 10px 0 10px 5px;width: calc(100% - 50px);height: 30px;line-height: 30px">历史版本</div>
        <div >
          <frame-form ref="toolItemHistory" component-param="tool_product_item_form"></frame-form>
        </div>
      </div>
    </div>

    <div>
      <div style="margin: 10px;border: 1px solid gray;display: flex;flex-wrap: wrap;">
        <div style="margin: 10px 0 0 10px;background-color: #108ffe;width: 5px;height: 30px"></div>
        <div style="margin: 10px 0 10px 5px;width: calc(100% - 50px);height: 30px;line-height: 30px">功能模块</div>
        <div >
          <frame-form ref="toolItemFunction" component-param="tool_product_item_form"></frame-form>
        </div>
      </div>
    </div>

    <div>
      <div style="margin: 10px;border: 1px solid gray;display: flex;flex-wrap: wrap;">
        <div style="margin: 10px 0 0 10px;background-color: #108ffe;width: 5px;height: 30px"></div>
        <div style="margin: 10px 0 10px 5px;width: calc(100% - 50px);height: 30px;line-height: 30px">价格列表</div>
        <div >
          <frame-form ref="toolItemPrice" component-param="tool_product_item_form"></frame-form>
        </div>
      </div>
    </div>

    <div>
      <div style="margin: 10px;border: 1px solid gray;display: flex;flex-wrap: wrap;">
        <div style="margin: 10px 0 0 10px;background-color: #108ffe;width: 5px;height: 30px"></div>
        <div style="margin: 10px 0 10px 5px;width: calc(100% - 50px);height: 30px;line-height: 30px">相关产品</div>
        <div >
          <frame-form ref="toolItemAbout" component-param="tool_product_item_form"></frame-form>
        </div>
      </div>
    </div>

    <div>
      <div style="margin: 10px;border: 1px solid gray;display: flex;flex-wrap: wrap;">
        <div style="margin: 10px 0 0 10px;background-color: #108ffe;width: 5px;height: 30px"></div>
        <div style="margin: 10px 0 10px 5px;width: calc(100% - 50px);height: 30px;line-height: 30px">业务联络</div>
        <div >
          <frame-form ref="toolItemBusiness" component-param="tool_product_item_form"></frame-form>
        </div>
      </div>
    </div>

    <div style="margin-top: 10px;margin-bottom: 20px;text-align: center">
      <el-button style="width: 100px"  type="primary" @click="saveData()" >保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ToolProductAdd",
  inject: ['$fn'],
  data() {
    return {
      toolProductForm : {},
      toolItemDetail: {},
      toolItemHistory: {},
      toolItemFunction: {},
      toolItemPrice: {},
      toolItemAbout: {},
      toolItemBusiness: {},
    }
  },
  created() {

  },
  methods: {
    async saveData(){
      this.toolProductForm = this.$refs.toolProductForm?.formInfo;
      this.toolItemDetail = this.$refs.toolItemDetail?.formInfo;
      this.toolItemHistory = this.$refs.toolItemHistory?.formInfo;
      this.toolItemFunction = this.$refs.toolItemFunction?.formInfo;
      this.toolItemPrice = this.$refs.toolItemPrice?.formInfo;
      this.toolItemAbout = this.$refs.toolItemAbout?.formInfo;
      this.toolItemBusiness = this.$refs.toolItemBusiness?.formInfo;

      let params = {...this.toolProductForm};
      params.software_detail_image_ids = this.toolItemDetail.image_ids;
      params.history_image_ids = this.toolItemHistory.image_ids;
      params.function_image_ids = this.toolItemFunction.image_ids;
      params.price_image_ids = this.toolItemPrice.image_ids;
      params.about_product_image_ids = this.toolItemAbout.image_ids;
      params.business_image_ids = this.toolItemBusiness.image_ids;
      await this.$http('toolWarehouseService.addToolWarehouse',params);
      this.$fn.closeWindow();
      this.$fn.search();

    }

  },
}
</script>

<style scoped>

</style>